import { ImageData } from "@swivl-mono/types";
import React from "react";

interface ImageProps {
  data: ImageData;
}

/**
 * `image` structured-message renderer (ENG-2828) — an agent-attached image.
 *
 * Display-only: no actions, no selected state. The image opens full-size in a
 * new tab on click (the S3 URL is public). Constrained to the bubble width;
 * broken URLs fall back to a plain link so the timeline never shows a dead
 * <img> box.
 */
export function ImageAttachment({ data }: ImageProps): React.ReactElement {
  const [failed, setFailed] = React.useState(false);
  const alt = data.fileName || "attachment";

  if (failed) {
    return (
      <a className="text-sm break-all underline" href={data.url} rel="noreferrer" target="_blank">
        {alt}
      </a>
    );
  }

  return (
    <a href={data.url} rel="noreferrer" target="_blank">
      <img alt={alt} className="max-h-64 max-w-full rounded-lg object-contain" src={data.url} onError={() => setFailed(true)} />
    </a>
  );
}
